let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "https://s3-noi.aces3.ai/invent-co-new/";
let URL;

console.log("appMode", appMode);

// 3.20.147.34

if (appMode === "development") {
  // URL = "http://103.189.173.7:1200/api/";
  // URL = "https://backend.wehadbot.com/api/";
  URL = "https://whtb.coffeeandaslice.com/api/";
} else {
  // URL = "https://backend.wehadbot.com/api/";
  // URL = "https://backend.wehadbot.com/api/";
  // URL = "https://backend.wehadbot.com/api/";
  // URL = "https://backend.wehadbot.com/api/";

  //URL = "https://backend.wehadbot.com/api/";
  URL = "https://whtb.coffeeandaslice.com/api/";
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "business/auth/dashboard-data",
  importStockData: "business/dashboard/import-stock-price",
  getStockData: "common/dashboard/get-stock-price",

  order: "business/order",
  viewOrder: "business/order/view",
  statusOrder: "business/order/status",
  transaction: "business/transaction",

  // Auth API
  logout: "business/auth/logout",
  // login: "business/auth/login",

  allRole: "business/role",
  login: "business/auth/login",
  register: "business/auth/sign-up",

  addNumber: "business/wati/addContacts",
  getContacts: "business/wati/getContacts",
  getMessages: "business/wati/getMessages",
  sendMessages: "business/wati/sendMessages",

  profile: "business/user/get-profile",
  // dashboard: "business/user/dashbaord-data",
  updateProfile: "business/user/update-profile",
  changePassword: "/business/user/change-password",
  updateAppSetting: "business/auth/update-app-setting",

  forgotPassword: "business/auth/forgot-password",
  verifyOTP: "business/auth/verify-otp",
  resetPassword: "business/auth/reset-password",

  // SubAdmin APIs
  subAdmin: "business/sub-admin",
  addEditSubAdmin: "business/sub-admin",
  statusSubAdmin: "business/sub-business/status",
  viewSubAdmin: "business/sub-business/view",
  getModule: "business/sub-business/module-list",
  addPermission: "business/sub-business/add-permission",
  log: "business/change-log",
  logRead: "business/change-log/read",

  // Role APIs
  role: "business/role",
  statusRole: "business/role/status",

  // Customer APIs
  listCustomer: "business/customer",
  addEditCustomer: "business/customer",
  viewCustomer: "business/customer/view",
  deleteCustomer: "business/customer/delete",
  statusCustomer: "business/customer/status",
  importCustomer: "business/customer/import-file",
  getPairings: "business/customer/pairings",
  getUserStats: "business/customer/stats",
  getUserchlg: "business/customer/challenges",
  getStoreData: "business/customer/store-data",

  // Challenge APIs
  addChallenge: "business/challenge",
  getChallenges: "business/challenge",
  statusChallenge: "business/challenge/status",
  deleteChallenge: "business/challenge/delete",
  getEmojis: "business/challenge/emojis",
  getChallengePieChart: "business/challenge/pie-chart",

  // Challenge APIs
  getUserChallenges: "business/user-challenge",
  getUserChallengeHistory: "business/user-challenge/history",
  getUserChallengeJRHistory: "business/customer/challenge-journey-history",

  // Challenge APIs
  getSupport: "business/support",

  // Feed APIs
  addFeed: "business/feed",
  getFeeds: "business/feed",
  getFeedcomments: "business/feed/comment-list",
  deleteFeedComment: "business/feed/delete-comment",
  deleteFeed: "business/feed/delete",

  // Order APIs
  orderList: "business/customer/order",
  transactionList: "business/customer/transaction",

  //Coupon Apis
  listCoupon: "business/coupon",

  // LeaderBoard APIs
  getLeaderboard: "business/leaderboard",

  banner: "business/banner",
  adminCommon: "business/common",

  // Content APIs
  content: "business/content",
  notification: "business/notification",
  notificationRead: "business/notification/read-all",
  rating: "business/rating",

  // EmailTemplate APIs
  listEmailTemplate: "business/email-template/list",
  addEditEmailTemplate: "business/email-template/add-edit",
  statusEmailTemplate: "business/email-template/status",
  viewEmailTemplate: "business/email-template/view",
  sendMail: "business/email-template/send-mail",

  //category
  listCategory: "business/category",
  statusCategory: "business/category/status",

  //Content Media
  contentMedia: "business/media-content",

  //Attribute List
  listAttribute: "business/attribute",

  //Question List
  listQuestion: "business/question/list",
  addQuestion: "business/question/add-question",
  editQuestion: "business/question/edit-question",
  viewQuestion: "business/question/view-question",
  deleteQuestion: "business/question/delete-question",

  //Manage Content List
  getContent: "business/manage-content/get",
  createContent: "business/manage-content/add",
  editContent: "business/manage-content/edit",
  deleteContent: "business/manage-content/delete-content",


  //Manage Device 
  getdevice: "business/device/get",
  getdeviceBYId: "business/device/get/:id",
  createdevice: "business/device/add",
  editdevice: "business/device/edit",
  deletedevice: "business/device/delete-device",
  deviceStatusChange: "business/device/status-change",
  getCount: "business/device/get-count",


  getSchedule: "business/schedule/get-list",
  createScheduleMessage: "business/schedule/add-schedule",
  UpdateScheduleMessage: "business/schedule/edit-schedule",
  UpdateScheduleMessageStatus: "business/schedule/status-schedule",




  getTemplate: "business/template/get-list",
  createTemplate: "business/template/add-template",
  editTemplate: "business/template/edit-template",


  planPurchase: "business/subscription/plan-purchase",
  //Product catalogue
  listProduct: "business/product",
  viewProduct: "business/product/view",
  listProductVariant: "business/product-variant",

  common: {
    notification: "common/notify",
    content: "common/content",
    categories: "common/categories",
    allCustomer: "common/users",
    challenges: "common/challenges",
    attributes: "common/attributes",
    subAdmin: "common/sub-admin",
    question: "common/question-list",
    subscription: "common/subscription-list",
    paymentMethod: "common/payment-method-list",
  },
};

export default apiPath;
